import React, { useMemo } from 'react'
import moment from 'moment'

import { Text } from '../presentation/Text'
import FlexGrid from '../structure/FlexGrid'
import NumberInput from './NumberInput'
import { COLORS } from '@btime/constants'

const TimeInput = ({ value, onChange, ...props }) => {
  let mValue = moment(value || undefined)

  const hour = useMemo(() => !!value && mValue.hour(), [value])
  const min = useMemo(() => !!value && mValue.minute(), [value])

  const handleChange = type => newValue => {
    mValue[type](newValue)
    onChange(mValue.toDate())
  }

  return (
    <FlexGrid gutter={0.5}>
      <NumberInput
        placeholder="Hora"
        type="number"
        max={23}
        min={0}
        align="center"
        value={hour}
        onChange={handleChange('hour')}
        {...props}
      />
      <Text color={COLORS.dark5} size="h4">
        :
      </Text>
      <NumberInput
        placeholder="Min."
        type="number"
        max={59}
        min={0}
        align="center"
        value={min}
        onChange={handleChange('minute')}
        {...props}
      />
    </FlexGrid>
  )
}

export default TimeInput
